var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 18 14",
    fill: "#1FA37C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79506 10.8749L2.32506 7.4049C1.93506 7.0149 1.30506 7.0149 0.915059 7.4049C0.525059 7.7949 0.525059 8.4249 0.915059 8.8149L5.09506 12.9949C5.48506 13.3849 6.11506 13.3849 6.50506 12.9949L17.0851 2.4149C17.4751 2.0249 17.4751 1.3949 17.0851 1.0049C16.6951 0.614902 16.0651 0.614902 15.6751 1.0049L5.79506 10.8749Z",
    fill: "#1FA37C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.f23bf82f50d9fdabc07d46c9d3bee675.svg";
export { ForwardRef as ReactComponent };